import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import {Router} from "@angular/router";
import { DefaultFrameComponent } from '../../../../frames/default-frame/default-frame.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'kaz-cancel-ad',
    templateUrl: './cancel-ad.component.html',
    styleUrls: ['./cancel-ad.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent, FaIconComponent]
})
export class CancelAdComponent {
  private _router = inject(Router);


  ngOnInit() {
    setTimeout(() => {
      this._router.navigate(['profile']).then();
    }, 4000);
  }
}
